import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-header-title" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "tag-select-wrap" }
const _hoisted_6 = ["id", "value"]
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = { class: "modal-footer-buttons" }

import { ref, onMounted } from "vue";
import { Profile } from "@/models/profile/profile";

// ---- Constant ----------------------------------------------
const componentId = "generalpurpose04-02-a-modal02";

export default /*@__PURE__*/_defineComponent({
  __name: 'InterestModal',
  props: {
    selectedInterests: {}
  },
  emits: ["close", "save"],
  setup(__props: any, { emit: __emit }) {

const profile = new Profile();

// ---- Variable ----------------------------------------------
const props = __props;
const emits = __emit;

const interestOptions = ref<{ id: number; name: string }[]>([]); // 本画面で選択したオプション
const selectedIds = ref<number[]>([...props.selectedInterests]); // 親からもらったオプション
const isLoading = ref(true);
// エラー
const hasError = ref(false);
let errorMessage: string;

// ----- Function -----------------------------------------------
// タグ情報取得
const fetchInterestOptions = async () => {
  await profile.getInterestOptions().then(([model, _response, err]) => {
    if (err) {
      errorMessage = decodeURIComponent(err.error?.response?.data?.message);
      hasError.value = true;
      return;
    } else {
      interestOptions.value = model.attributes?.result || null;
    }
    isLoading.value = false;
  });
};

// 保存処理
const saveSelection = () => {
  const selectedNames = interestOptions.value
    .filter((option) => selectedIds.value.includes(option.id))
    .map((opiton) => opiton.name)
    .join(", ");

  emits("save", selectedIds.value, selectedNames);
};

onMounted(async () => {
  await fetchInterestOptions();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { id: componentId }, [
    _createElementVNode("body", null, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "modal-overlay" }, null, -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("profile_edit_interest_modal_header")), 1),
          _createElementVNode("button", {
            type: "button",
            class: "modal-close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("img", { src: "/server/necs/images/close-btn.png" }, null, -1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(interestOptions.value, (option) => {
              return (_openBlock(), _createElementBlock("li", {
                key: option.id,
                class: "tag-select-item",
                id: "tag_name"
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "tag-select-name",
                  id: `tag_name_${option.id}`,
                  value: option.id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedIds).value = $event))
                }, null, 8, _hoisted_6), [
                  [_vModelCheckbox, selectedIds.value]
                ]),
                _createElementVNode("label", {
                  for: `tag_name_${option.id}`
                }, [
                  _createElementVNode("span", null, _toDisplayString(option.name), 1)
                ], 8, _hoisted_7)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: _normalizeClass(["modal-footer-error", hasError.value ? 'active' : ''])
          }, _toDisplayString(_unref(errorMessage)), 3),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              type: "button",
              class: "modal-cansel",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
            }, _toDisplayString(_ctx.$t("button_cancel_label")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "modal-ok",
              onClick: saveSelection
            }, _toDisplayString(_ctx.$t("button_ok_label")), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})